import {getRuntimeConfig} from 'core/next/helpers';

export const CAPTCHA_SITE_KEY = getRuntimeConfig().NEXT_PUBLIC_CAPTCHA_SITE_KEY ?? '';
export const CAPTCHA_CONTAINER = 'captcha-container';
export const CAPTCHA_SCRIPT_ID = 'captcha-script';
export const CAPTCHA_MOBILE_CB_SCRIPT_ID = 'captcha-mobile-script';
export const CAPTCHA_SCRIPT_SRC = getRuntimeConfig().NEXT_PUBLIC_CAPTCHA_SCRIPT_SRC ?? '';
